import React from 'react'
import './LogisticsContent.scss'
import CallToActionBanner from '../../CallToActionBanner/CallToActionBanner'
import { Link } from '@reach/router'
import { FaLink, FaSatelliteDish, FaExclamationTriangle, FaSyncAlt, FaCheck } from 'react-icons/fa'

export class LogisticsContent extends React.Component {
  render() {
    return (
      <div className="logistics-content">
        <div className="split light subheader-block">
          <div className="text-wrap">
            Rackner brings proven experience modernizing mission-critical Navy
            logistics systems, combining software engineering excellence with
            AI-powered analytics to improve fleet readiness, reduce analyst
            workload, and transform disconnected data into actionable intelligence.
          </div>
        </div>

        <section className="padding-large">
          <h2>Featured Programs</h2>
          <div className="row programs-row">
            <div className="col-md-6">
              <div className="program-card">
                <div className="program-name">Navy Forge</div>
                <div className="program-description">
                  The Navy's first weapons system software factory supporting
                  surface combatant modernization with DevSecOps automation and
                  RAISE 2.0 compliant platform engineering.
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="program-card">
                <div className="program-name">AMC NITMRE</div>
                <div className="program-description">
                  Applied Natural Language Processing and AI to transform
                  disconnected communications data into structured intelligence,
                  reducing analyst workload by 40% - featured in CSAF General Allvin's
                  keynote at Sea, Air, Space 2025.
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="split pattern">
          <h2>Logistics Challenges We Solve</h2>
          <div className="row challenges-grid">
            <div className="col-md-6">
              <div className="challenge-card">
                <div className="icon"><FaLink /></div>
                <div className="content">
                  <div className="title">Fragmented Legacy Systems</div>
                  <div className="description">
                    Integrate disparate data sources into unified views with
                    automated reconciliation and real-time synchronization.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="challenge-card">
                <div className="icon"><FaSatelliteDish /></div>
                <div className="content">
                  <div className="title">DDIL Network Environments</div>
                  <div className="description">
                    Architect for Disconnected, Degraded, Intermittent, or Limited
                    networks with offline-first capabilities and intelligent sync.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="challenge-card">
                <div className="icon"><FaExclamationTriangle /></div>
                <div className="content">
                  <div className="title">Data Non-Standardization</div>
                  <div className="description">
                    Detect discrepancies and alert operators before data gaps
                    impact mission decisions using AI-powered validation.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="challenge-card">
                <div className="icon"><FaSyncAlt /></div>
                <div className="content">
                  <div className="title">24/7 Operational Support</div>
                  <div className="description">
                    Modernize systems while maintaining continuous operations
                    through blue-green deployments and zero-downtime updates.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="padding-large light">
          <h2>Specialized Capabilities</h2>
          <div className="capabilities-list">
            <div className="capability-row">
              <div className="capability-icon"><FaCheck /></div>
              <div className="capability-text">
                <strong>Fleet Readiness Systems:</strong> Parts provisioning,
                configuration management, and technical data delivery for surface
                combatants and logistics operations.
              </div>
            </div>
            <div className="capability-row">
              <div className="capability-icon"><FaCheck /></div>
              <div className="capability-text">
                <strong>AI-Enabled Analytics:</strong> Natural Language Processing
                to extract insights from communications, reports, and unstructured
                data sources.
              </div>
            </div>
            <div className="capability-row">
              <div className="capability-icon"><FaCheck /></div>
              <div className="capability-text">
                <strong>Automated Reconciliation:</strong> Tools that automatically
                reconcile information across fragmented sources with real-time
                discrepancy detection.
              </div>
            </div>
            <div className="capability-row">
              <div className="capability-icon"><FaCheck /></div>
              <div className="capability-text">
                <strong>DevSecOps Automation:</strong> CI/CD pipelines, automated
                testing, and security scanning aligned with Navy RMF and ATO
                requirements.
              </div>
            </div>
          </div>
        </section>

        <div className="split">
          <h2>Trusted Defense Logistics Partner</h2>
          <div className="partnership-block">
            <p>
              Rackner is a trusted partner for USTRANSCOM and its component
              commands, delivering software solutions that support global mobility
              operations including airlift and sealift. Our teams bring deep
              understanding of defense logistics ecosystems, enabling us to rapidly
              modernize mission-critical systems while maintaining operational
              continuity across supply chain, fleet readiness, and transportation
              missions.
            </p>
          </div>
          <div className="button-wrap">
            <Link to="/contact">
              <button className="btn-raised-light-blue-inverse big">
                Discuss Your Logistics Needs
              </button>
            </Link>
          </div>
        </div>

        <CallToActionBanner route={'insights'} linkText={'See Case Studies'} />
      </div>
    )
  }
}

export default LogisticsContent
